import React from "react";
import {Col, FormGroup} from "reactstrap";
import Toggle from "react-toggle";
import PropTypes from "prop-types";
import "react-toggle/style.css";
import HelpIcon from "../../HelpIcon/HelpIcon";

const ToggleCreator = (props) => {
  const {
    colSize = "6",
    help_text,
    inSingleRow = false,
    label = false,
    large,
    testId = "toggle",
    ...rest
  } = props;

  return (
    <Col md={large ? "12" : colSize}>
      <FormGroup row id={testId}>
        <Col md={inSingleRow ? 3 : 12}>
          <div className="d-flex">
            <label className="form-control-label" htmlFor="input-name">
              {label}
            </label>
            {help_text && (
              <span style={{padding: "0px 5px"}}>
                <HelpIcon text={help_text} target={label} place="right" />
              </span>
            )}
          </div>
        </Col>
        <Col md={inSingleRow ? 9 : 12}>
          <Toggle {...rest} />
        </Col>
      </FormGroup>
    </Col>
  );
};

ToggleCreator.propTypes = {
  /** This prop will be passed as colSize to reactstrap Col component */
  colSize: PropTypes.string,
  /** If value is passed for this prop this will be shown as tooltip when hovered on help icon */
  help_text: PropTypes.string,
  /** Wether to show label and input field in single row */
  inSingleRow: PropTypes.bool,
  /** Label for form field */
  label: PropTypes.string,
  /** If this prop is set to true then this component will take 100% width of parent component */
  large: PropTypes.bool,
  /** Id which will be passed as data-cy attribute to form control component */
  testId: PropTypes.string,
};

export default ToggleCreator;
